import { type FC } from "react";

import { ChartRange } from "~/feature/chart/components/ChartRange";

import { ChartSettings } from "../ChartSettings";
import { ResolveDate } from "../ResolveDate";
import { VolumeIndicator } from "../VolumeIndicator";
import * as Styled from "./Footer.styles";

export const Footer: FC = () => {
  return (
    <Styled.Root>
      <Styled.RangeSlot>
        <ChartRange />
      </Styled.RangeSlot>

      <Styled.Info>
        <VolumeIndicator />
        <Styled.Dot>·</Styled.Dot>
        <ResolveDate />
      </Styled.Info>

      <Styled.SettingsSlot>
        <ChartSettings />
      </Styled.SettingsSlot>
    </Styled.Root>
  );
};
